import React, { useState } from "react";
import { usePopper } from "react-popper";
import { Info } from "lucide-react";
import { Transition } from "@headlessui/react";
import { FieldInfoProps } from "../interfaces";

export const FieldInfo: React.FC<FieldInfoProps> = ({ info }) => {
  const [referenceElement, setReferenceElement] =
    useState<HTMLDivElement | null>(null);
  const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(
    null,
  );
  const [showTooltip, setShowTooltip] = useState(false);
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: "top",
    modifiers: [
      { name: "offset", options: { offset: [0, 3] } },
      { name: "preventOverflow", options: { padding: 8 } },
    ],
  });

  return (
    <>
      <div
        ref={setReferenceElement}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <Info className="h-3 w-3 shrink-0 text-gray-400" />
      </div>
      <Transition
        show={showTooltip}
        enter="transition duration-200 ease-out"
        enterFrom="opacity-0 translate-y-1"
        enterTo="opacity-100 translate-y-0"
        leave="transition duration-150 ease-in"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
      >
        <div
          ref={setPopperElement}
          style={styles.popper}
          {...attributes.popper}
          className="z-50 w-[280px] rounded-lg border border-gray-200 bg-white p-2 text-xs text-gray-900 shadow-sm"
        >
          {info}
        </div>
      </Transition>
    </>
  );
};
